import { MapChartConfig } from './mapChartTypes';

export const DEFAULT_MAP_CONFIG: MapChartConfig = {
    mode: 'bubbles',
    colorMode: 'value',
    paletteId: 'default',

    minBubbleRadius: 5,
    maxBubbleRadius: 20,
    bubbleOpacity: 0.8,

    regionOpacity: 0.6,
    regionBorderWidth: 1,
    regionBorderColor: '#333333',
    showRegionLabels: false,

    enableClustering: false,
    showTopPointLabels: false,

    autoFitToData: true,
    showZoomControls: true,
    showScaleBar: true,
    lockInteractions: false,

    legendPosition: 'br',
    legendLayout: 'vertical',
    legendType: 'gradient'
};
